// MUST be the first import so Sentry instruments the runtime before React.
import './observability.js';
// i18n must initialize before React renders (ISSUE-125 §1.1).
import './i18n.js';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import { Sentry } from './observability.js';
import { registerAppServiceWorker } from './pwa/register.js';
import './styles.css';

const queryClient = new QueryClient();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element not found');
}

const FallbackUI = () => (
  <main className="mx-auto flex min-h-dvh max-w-md flex-col items-start justify-center gap-3 p-8">
    <h1 className="text-2xl font-medium tracking-tight">Something went wrong</h1>
    <p className="text-ink-soft dark:text-ink-soft">We've been notified. Try reloading the page.</p>
    <button
      type="button"
      onClick={() => window.location.reload()}
      className="rounded border border-ink/20 px-3 py-1.5 text-sm hover:bg-shell dark:border-ink/20 dark:hover:bg-leaf"
    >
      Reload
    </button>
  </main>
);

createRoot(rootEl).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={FallbackUI}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);

registerAppServiceWorker();
